import type { FamilyKeySource } from '../api/client.js';

/**
 * Small shared helpers for the family pages: the route for a family key (the
 * key can be a seller SKU with characters that must be encoded), and the human
 * label for where a family key came from.
 */

/**
 * The detail route for a family key. The key rides in the query string (not the
 * path) so free-text overrides and seller SKUs with `/`, `.`, `%`, `#`, `&`, or
 * `+` route correctly.
 */
export function familyPath(key: string): string {
  return `/families/detail?key=${encodeURIComponent(key)}`;
}

/** Human label for the source of a family key, for tooltips and the SKU field. */
export const KEY_SOURCE_LABEL: Record<FamilyKeySource, string> = {
  override: 'a hand override',
  parent_asin: 'the parent ASIN',
  asin: "the SKU's own ASIN",
  seller_sku: 'the seller SKU',
};

/** Short label for the source, for a compact badge. */
export const KEY_SOURCE_SHORT: Record<FamilyKeySource, string> = {
  override: 'Override',
  parent_asin: 'Parent ASIN',
  asin: 'Own ASIN',
  seller_sku: 'Seller SKU',
};
